import {BaseModel} from './base.model';

export class UserPositionsModel extends BaseModel {
  id: string;
  name: string;
  isDefault: boolean;
}
